import { SET_TEXT_VALUE } from "../action";

export function setTextValue(textKey, textValue) {
  return (dispatch) => {
    dispatch({ type: SET_TEXT_VALUE, payload: { textKey, textValue } });
  };
}
